import { render } from "./wSelectTag.vue?vue&type=template&id=47793202&ts=true"
import script from "./wSelectTag.vue?vue&type=script&lang=ts"
export * from "./wSelectTag.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__